import React, { useEffect, useState,useRef } from 'react';
import logo from './logo.svg';
import './App.css';
import DD from './Sample'
import Form from './Form'
import Tran from './Tran'
import Modal from './Modal'
import Side from './SideSheet'
import Table from './Table'
import Footer from './component/Footer'
import DropD from './component/Dropdown'
import CartView from './component/CartView'
import ViewProduct from './component/ViewProduct'
import CategoryView from './component/CategoryItem'
import StandoutSale from './component/StandoutText'
import Showcase from './component/ShowcaseProduct'
import FooterV2 from './component/footerV2'
import FAQ from './component/FAQ'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { Card, CardPrice, Toggle, PlaceholderCard, SideCart, LandingHeader, CategoryPH } from './component'
import { Dialog } from '@headlessui/react'
import { axios } from './Network'
import FixedDatePicker from './component/FixedDatePicker'
import ProductCarousel from './component/ProductCarousel'
import ProductGallery from './component/ProductGallery'
import ProductgalleryV2 from './component/gallery'
import CTA from './component/CTA'
import PricingPlan from './component/PricingPlan'
import Reviews from './component/reviews'
import Addons from './component/Addons'
import ReactPlayer from 'react-player'
import { useMemo } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import ContentLoader from "react-content-loader"
import moment from 'moment'
import momentTZ  from 'moment-timezone'
import MessengerCustomerChat from 'react-messenger-customer-chat';
import ReactGA from 'react-ga';
import { fi } from 'date-fns/locale';
var timeInManila = momentTZ.tz('Asia/Manila');

ReactGA.initialize('UA-226511448-1', {
  debug: true,
  titleCase: false,
  gaOptions: {
    userId: 123
  }
});

const MyLoader = (props) => (
  <ContentLoader viewBox="0 0 400 31" height={200} width={'auto'} {...props}>
    <rect height="5.5" rx="1" ry="1" width="340" x="31" y="5" />
    <rect height="5.5" rx="1" ry="1" width="340" x="31" y="15" />
    <circle cx="388" cy="12" r="12" />
    <rect height="24" rx="0" ry="0" width="24" x="0" y="0" />
  </ContentLoader>
)
var id = process.env.REACT_APP_STORE_ID
 
function App() {
  const [status, setStatus] = useState(false)
  const [suggestStatus, setSuggestStatus] = useState(false)
  const [cart, setCartItems] = useState([])
  const [showCart, setShowCart] = useState(false)
  let [isOpen, setIsOpen] = useState(true)
  const [scroll, setScroll] = useState(0)
  const [didUpdate, setUpdate] = useState(true)
  const [product, setProducts] = useState([])
  const [addons, setAddonProduct] = useState([])
  const [suggestedProduct, setSuggestedProduct] = useState([])
  const [topItems, setTopItems] = useState([])
  const [category, setSelectedCategory] = useState('Flux-Bouquet')
  const [categories, setCategory] = useState([])
  const [storeDetails, setStoreInfo] = useState(null)
  const [hasVoucher, setHasVoucher] = useState(false)
  const [viewProduct, setCurrentView] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null)
  const listInnerRef = useRef();
  const [offset, setOffset] = useState(0);
  const [currentPage, setPage] = useState(8)
  const mainCategory = useRef();
  const [isBlack, setFrameColor] = useState(true)
  const [suggesteItem, setSuggestedItem] = useState({
    type: 'Lux-Arrangements',
    displayName: "Flower Boxes",
    title:'Lux-Arrangements'
  })
  var addonsID = 'Tart-Addons'
  const onScroll = () => {
    // if (listInnerRef.current) {
    //   const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
    //   console.log("reached bottom");
    //   if (scrollTop + clientHeight === scrollHeight) {
    //     console.log("reached bottom");
    //   }
    // }
  };
  const promoShout =()=> {
    return (
   <StandoutSale colorText="text-gray-800 md:text-5xl text-red-500 text-2xl font-bold text-center"  colorText2="text-black md:text-6xl text-red-500 animate-bounce sm:text-6xl lg:text-6xl xl:text-6xl font-bold   text-4xl   mb-12  text-center" smallText='Limited Stocks' biggerText='Hurry!'/>
    )
  }
  const shout1 =()=> {
    return (
   <StandoutSale smallText='up to' biggerText='100kg Max Load.'/>
    )
  }
  const shout2 =()=> {
    return (
   <StandoutSale smallText='Powered by ' biggerText='Dual Motor.'/>
    )
  }
  const shout3 =()=> {
    return (
   <StandoutSale smallText='' biggerText='Total Silent.'/>
    )
  }
  const shout4 =()=> {
    return (
   <StandoutSale smallText='Built with' biggerText='Pure Solid Wood.'/>
    )
  }
   const shout5 =()=> {
    return (
   <StandoutSale smallText='4cm' biggerText='Super Thick'/>
    )
  }
  const finder = (e) => {
    let userSeletedDate = localStorage.getItem('userQ')
    var date = JSON.parse(userSeletedDate)
    if (e != undefined) {
      var filterd =  e.filter( data => moment(data.date).format("YYYY-MM-DD") === moment(date.date).format("YYYY-MM-DD"))
      if (filterd.length){
        return filterd[0]
      }
    } 
  }
  const products = {
    white: {
     big:{
         image1: 'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650079898624-cc1.png',
         image2:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650075997652-691.png'
     },
     smallBottom:{
         image1:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039298499-502x302.png',
         image2:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039520264-2.png'
     },
     top:{
         image1:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039708120-b23.png',
         image2:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039867851-v1.png'
     }
    },
    black:{
     top:{
         image1:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039708120-b23.png',
         image2:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650039867851-v1.png'
     },
        big:{
            image1:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650082192667-bg23.png',
            image2:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650082469034-smallBottom.png'
        },
        smallBottom:{
         image1:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650080756249-bgsma.png',
         image2:'https://localflowershop.sgp1.digitaloceanspaces.com/product/1650082864605-smallBottom%20%281%29.png'
     },
       
    }

 }
  const productFilter = (e,state)=> {
    var filtered =  []
    console.log("DATA,",e)
    e.map((item)=>{
      var price = finder(item.priceSurgesDates)
      if (item.priceSurgesDates != undefined &&  item.priceSurgesDates.length && price != undefined ) {
          console.log()
        item.price = price.price
        filtered.push(item)
      }else {
        filtered.push(item)
      }
    })
  console.log(filtered.length)
    state(filtered)
    setStatus(false)
    setSuggestStatus(false)
  }

  React.useEffect(async () => {

  ReactGA.outboundLink(
    {
      label: `User wanted ${isBlack ? 'Black': 'White'} frame`
    },
    function () {
      console.log('');
    },
    ['tracker2']
  );
  },[isBlack])
  React.useEffect(async () => {
    console.log('mainCategory', mainCategory.current)
    ReactGA.pageview(window.location.pathname + window.location.search);
  
    try {
      window.onscroll = () => {
        listInnerRef.current = window.pageYOffset
        setOffset(window.pageYOffset)
      } 
      fetchStoreProduct(category,8).then(data => {
        if (data === undefined) {
          toast('Please try again later..')
        } else {
          productFilter(data.data.results,setProducts)
        }
      })
      fetchStoreProduct(suggesteItem.type,8).then(data => {
        if (data === undefined) {
          toast('Please try again later..')
        } else {
          console.log('data.data.results',data.data.results)
          productFilter(data.data.results,setSuggestedProduct)
        }
      })
      loadProductCategory()
      let existingCart = localStorage.getItem('UserCart')
      if (existingCart !== null) {
        let jsonCart = JSON.parse(existingCart)
        setCartItems(jsonCart)
      }

    } catch (error) {
      toast('Please try again later..')
    }
  }, [])


  function addRemoveItem(e, status) {
    if (status) {

      setCartItems(prevArray => [...prevArray, e])
      let existingCart = cart
      if (cart.length) {

        let existingCart = localStorage.getItem('UserCart')
        let jsonCart = JSON.parse(existingCart)
        jsonCart.push(e)
        localStorage.setItem('UserCart', JSON.stringify(jsonCart));
      } else {
        let initialCart = []
        initialCart.push(e)
        localStorage.setItem('UserCart', JSON.stringify(initialCart));
      }
    } else {
      let filteredCart = cart.filter(item => item._id !== e._id)
      setCartItems(filteredCart);

      localStorage.setItem('UserCart', JSON.stringify(filteredCart));
    }
    setUpdate(true) 
  }

  function loadSuggestedOnly(type,page){
    try {
      fetchStoreProduct(type,page).then(data => {
        setSuggestedProduct([])
        productFilter(data.data.results,setSuggestedProduct)
      })
    }catch (error) {
      setSuggestedProduct([])
    }
  }
  function reload(type,page,withSuggested) {

    if (!withSuggested) {
      mainCategory.current = type
    }

      setStatus(true)
      setSelectedCategory(type)
      fetchStoreProduct(type,page).then(data => {
        setProducts([])
        // setProducts(data.data.results)
        productFilter(data.data.results,setProducts) 
        window.scrollTo(0, 1020)
      }) 
      if (withSuggested) {
        let suggested = categories.filter(data => data.title != type && data.status == true)
        var item = suggested[Math.floor(Math.random() * suggested.length)] 
        try {
          console.log("item",item)
          setSuggestedItem(item)
          fetchStoreProduct(item.title,page).then(data => {
            setSuggestedProduct([])
            setSuggestedProduct(data.data.results,setProducts)
          })
        }catch (error) {
          setSuggestedProduct([])
        }
        
      }

 
  }
  function loadProductCategory() {
    let parameter = {
      id: id,
      equalTo: true, storeOwner: id, cType: "Product", cName: "Category"
    }
    axios
      .post("/details/Store", parameter)
      .then((response) => {
        setCategory(response.data.results[0].productCategories)
        setStoreInfo(response.data.results[0])
        document.title = "SmartDeskPh-  In Action Desk"
      })
      .catch(function (error) {
        console.log('fetching product', error)
      });
  }
  async function fetchStoreProduct(item,page) {
    try {
      var defaultDate =  new Date()
      var convertedUserDate = momentTZ(defaultDate).tz("Asia/Manila").format("yyyy-mm-dd")
      let userSeletedDate = localStorage.getItem('userQ')
      var date = JSON.parse(userSeletedDate) 
      const data = { id: item, queryType: "filter", storeOwner: '5ff00ddaeb2f5d0940dfa186', isAPI: true,showLimit:true,number:page ,deliveryDate:moment(date.date).format("YYYY-MM-DD")}
      const response = await axios.post('/productV2/Product', data)
      return response
    } catch (error) {

      toast('Please try again later..')
    }
  }
  function renderCategories() {
    var data = []
    categories.map(item => {
      if (item.status) {
        data.push(
          <CategoryView onClick={(e) => reload(e,8)} active={category} data={item} />
        )
      }
    })
    return data
  }
  function renderItem(source) {
    var data = []
    var sortedProduct = source.sort((a, b) => parseInt(a.price) - parseInt(b.price));
    var sourceItem = sortedProduct
    var activePromo = storeDetails.storeOptions.activeCategoryPromo[0].category
    if (sourceItem.length) {
      sourceItem.map(item => {
        var isAdded = cart.filter(data => data._id === item._id).length === 0 ? false : true
        data.push(
          <>
            {/* {cadView(item)} */}
            <Card activePromo={activePromo} type="Display" view={(e) => setCurrentView(e)} update={didUpdate} existing={isAdded} item={item} didAdd={(item) => addRemoveItem(item, true)} didRemove={(item) => addRemoveItem(item, false)} />
          </>
        )
      })
      return data
    } else {
      for (var i = 0; i < 4; i++) {
        data.push(
          <PlaceholderCard />
        )
      }
      return data
    }
  }

  const displayNotice = () => {
    var content = <div></div>
    if (storeDetails !== null && storeDetails.storeOptions.siteHeaderNotice.status) {
      var details = storeDetails.storeOptions.siteHeaderNotice
      content = (<div className="sticky top-0 z-50 flex-1 overflow-y-auto  lg:h-15 sm:h-10 transform transition duration-400 " style={{ backgroundColor: '#ecf0f1' }}>
        <div className="flex ... items-center justify-center w-full  mt-2 uppercase text-4 tracking-tight  font-extralight text-gray-900 " >
          <span className='text-2xl font-bold text-black '>
          {details.value}
            </span>
        </div>
      </div>)
    }

    return content
  }

  const loadItem =(item,page,primary)=>{
    setPage(page)
    if (primary) {
      reload(item,page,false)
    } else {
      loadSuggestedOnly(item,page,true)
      setSuggestStatus(true)
    }
  }

  const validateCart =()=>{
    let existingCart = localStorage.getItem('UserCart')
    if (existingCart !== null) {
      let jsonCart = JSON.parse(existingCart)
      console.log(jsonCart.length)
      setCartItems(jsonCart.length == 0  ? []  : jsonCart)
    }else {
      setCartItems([])
    }
  }
  const billeaseContent =()=>{
    return (

      <div class="container mx-auto py-9 md:py-12 px-4 md:px-6">
      <div class="flex items-strech justify-center flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6 lg:space-x-8">
        <div class="flex flex-col md:flex-row items-strech justify-between bg-gray-50 hover:bg-white dark:bg-gray-800 py-6 px-6 md:py-12 lg:px-12 md:w-8/12 lg:w-7/12 xl:w-8/12 2xl:w-9/12">
          <div class="flex flex-col justify-center md:w-1/2">
            <h1 class="text-3xl lg:text-4xl font-semibold text-gray-800 dark:text-white">Blissful Shopping. Easy Billing.</h1>
            <p class="text-base lg:text-xl text-gray-800 dark:text-white mt-2">We are offering card-free buy now, pay later.</p>
          </div>
          <div class="md:w-auto mt-8 md:mt-0 flex justify-center md:justify-end rounded-sm" >
            <a href="https://billease.ph/">
            <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1647863516804-billease.png" alt="" class="h-40 w-auto rounded-lg"  />
            </a>
          </div>
        </div>
      </div>
    </div>
    )
  }
  const beastContent =()=>{
    return (

      <div class="bg-black relative overflow-hidden h-screen">
      <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1649943541512-prod1%20%281%29.png" class="absolute h-full w-full object-cover"/>
      <div class="inset-0 bg-black opacity-25 absolute">
      </div>
      <div class="containerrounded-lg mx-auto w-4/5 relative z-10 flex items-center py-16 my-24 md:my-32">
          <div class="w-full flex flex-col items-center justify-between relative z-10">
              <p class="flex uppercase flex-col items-centertext-6xl text-center md:text-8xl font-extralight text-white">
               Meet the beast!
              </p>
              <p class="flex flex-col max-w-lg text-center items-center font-extralight text-lg mt-6 text-white">
              Made by our talented craftsman
              </p>
    
          </div>
      </div> 
  </div>
    )
  }
  const dualMotorContent1=()=>{
    return(

<div class="bg-white relative overflow-hidden h-screen">

<img src={ isBlack ? "https://clouddisk.alibaba.com/file/redirectFileUrl.htm?appkey=OneChat&id=687739271&parentId=648781579&secOperateAliId=MC1IDX1kM-MR-7BPeDBIwbElTZ3pPEOK07tBVtyj8FpUP6LloWGv1vCw-QwSZ61E9LoiHzz&fileAction=imagePreview" : 'https://sc04.alicdn.com/kf/H2d0c061170c340209dc14680c058ef93M.jpg'} class="rounded-lg absolute h-full w-full object-contain"/>
<div class="inset-0 bg-white opacity-0 absolute">
</div>
<div class="containerrounded-lg mx-auto w-4/5 relative z-10 flex items-center py-16 my-24 md:my-32">
    <div class="w-full mt-20 flex flex-col items-center justify-between relative z-10">
        <p class="flex uppercase flex-col items-centertext-6xl text-center md:text-8xl font-extralight text-black">
         DUAL SILENT MOTOR
        </p>
        <p class="flex flex-col max-w-lg text-center items-center font-extralight text-lg mt-6 text-white">
      P 18,000 
        </p>
        <p class="flex flex-col max-w-lg text-center items-center font-extralight text-lg mt-6 text-white">
      P 16,200 
        </p>
        <button className="bg-black rounded-full mt-10">
      <a 
    href="https://store.smartdeskph.com"
    ><span className="text-white text-xs mr-5 ml-5 m-5"> Buy </span></a>
    </button>
    </div>
</div> 
</div>

    )
  }

  const ModeOfPayments = () =>{
    return (
       
      <div className="text-black flex flex-col items-center mt-40 mb-10 f-f-l pt-3">
{/* <h1 className="text-1xl   uppercase font-extralight text-gray-500 " >Mode of Payments</h1> */}
<h5 class="font-medium group-hover:opacity-0 opacity-100 ease-out duration-300">
Available Payments
                  </h5>
<div className="my text-base text-color f-f-l">
    <ul className="flex items-center">
      <div class="hover:opacity-60 opacity-100 w-col w-col-3 w-col-small-6 w-col-tiny-6 mr-2">
      <img src="https://mindanaotimes.com.ph/wp-content/uploads/2021/05/GCash-Logo-Transparent-PNG-1.png" loading="lazy" width="100" alt=""/>
      </div>
      <div class="hover:opacity-60 w-col w-col-3 w-col-small-6 w-col-tiny-6 mr-2">
      <img src="https://cdn.pixabay.com/photo/2015/05/26/09/37/paypal-784404_960_720.png" loading="lazy" width="100" alt=""/>
      </div>
      <div class="hover:opacity-60 w-col w-col-3 w-col-small-6 w-col-tiny-6 mr-2">
      <img src="https://businessweekmindanao.com/wp-content/uploads/2022/07/bpi-logo-bank-of-the-philippine-islands.png" loading="lazy" width="100" alt=""/>
      </div>
      <div class="hover:opacity-60 w-col w-col-3 w-col-small-6 w-col-tiny-6 mr-2">
      <img src="https://s3-ap-southeast-1.amazonaws.com/static.fdfc.io/billease-logo.png" loading="lazy" width="100" alt=""/>
      </div>
    </ul>
</div>
</div>
    )
  }
  
  return (
    <div onContextMenu={(e)=> e.preventDefault()}> 
<div className='w-full h-10  lg:h-90 xl:h-90  sm:h-90 md:h-90' />
<div className='w-full h-10 lg:h-90 xl:h-90  sm:h-90 md:h-90' />
{shout1()}
<div className=' w-full h-20 xl:h-80' />
<div className=' w-full h-20 xl:h-80' />
<div class="bg-white relative overflow-hidden h-screen ">
    <img src={isBlack ? "https://i.pinimg.com/564x/0e/d8/9b/0ed89b9530f9b17c7e9567ce414b6e2d.jpg" : 'https://localflowershop.sgp1.digitaloceanspaces.com/product/1670387558906-IMG_2491.jpg'} class=" absolute h-full w-full object-contain "/>
    <div class="inset-0 bg-white opacity-20 hover:opacity-0 absolute">
    </div>
    <div class="containerrounded-lg mx-auto w-4/5 relative z-10 flex items-center py-16 my-24 md:my-32">
        <div class="w-full mt-20 flex flex-col items-center justify-between relative z-10">
            <p class={isBlack ? "flex uppercase flex-col items-centertext-6xl text-center md:text-8xl font-extralight text-white" :"flex uppercase flex-col items-centertext-6xl text-center md:text-8xl font-extralight text-black" }>
          
            </p>
            <p class={isBlack ? "flex flex-col max-w-lg text-center items-center font-extralight text-lg mt-6 text-white" :"flex flex-col max-w-lg text-center items-center font-extralight text-lg mt-6 text-black" }>
          
            </p>
            <button className="bg-black rounded-full mt-10">
          <a 
        href="https://store.smartdeskph.com/"
        ><span className="text-white text-xs mr-5 ml-5 m-5"> Buy </span></a>
        </button>
        </div>
    </div> 
    
</div>

<div className='  w-full xl:h-80 sm:h-20 md:h-20' />
<div className='  w-full xl:h-80 sm:h-20 md:h-20' />
{shout2()}

<div className='  w-full h-5 lg-80 xl:h-80 sm:h-1 md:h-20 ' />
<div className='  w-full h-5 lg-80  xl:h-80 sm:h-20 md:h-20' />

<div class="bg-white relative overflow-hidden h-screen ">
    <img
     src="https://images.unsplash.com/photo-1622579522991-f2c1089b8fc2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MXw0NzUyMDA4M3x8ZW58MHx8fHw%3D&auto=format&fit=crop&w=900&q=60" 
    class=" absolute h-full w-full object-contain"/>
    <div class="inset-0  absolute">
    </div>
    <div class="containerrounded-lg mx-auto w-4/5 relative z-10 flex items-center py-16 my-24 md:my-32">
        <div class="w-full mt-20 flex flex-col items-center justify-between relative z-10">
            <p class="flex uppercase flex-col items-centertext-6xl text-center md:text-8xl font-extralight text-white">
    
            </p>
            <p class="flex flex-col max-w-lg text-center items-center font-extralight text-lg mt-6 text-white">
         Feel the power of dual Motor
            </p>
           
          <button className="bg-black rounded-full mt-10">
          <a 
        href="https://store.smartdeskph.com/"
        ><span className="text-white text-xs mr-5 ml-5 m-5"> Buy </span></a>
        </button>
        </div>
    </div> 
</div>

<CartView removeItem={(item) => addRemoveItem(item, false)} items={cart} />
    
      <div  style={{opacity:status ? 0.2 : 1}}>
        <div class="divide-y divide-gray-200">
          <div>
           

          </div>
        </div>
        {/* <img src="https://cdn-icons-png.flaticon.com/512/2630/2630085.png"
className='h-10 w-10'/>         */}
  {/* <!--- more free and premium Tailwind CSS components at https://tailwinduikit.com/ ---> */}


  <div className='  w-full  h-5 lg-80 xl:h-80 sm:h-1 md:h-20' />
<div className='  w-full  h-5 lg-80 xl:h-80 sm:h-1 md:h-20' />
{shout5()}

<div className='  w-full  h-5 lg-80 xl:h-80 sm:h-1 md:h-20' /> 
<div class="grid lg:grid-cols-3 lg:gap-3 md:grid-cols-3 md:gap-3 lf-4 lg:mr-4 md:mr-4  align-middle justify-center items-center">
  <div className='w-auto'/>
  
<img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1670386036315-smartdesk-wood.jpeg" class=" rounded-lg  w-full hover:shadow-lg object-contain transition ease-in-out "/>
<div className='w-auto'/>

</div>






<div className='  w-full  h-5 lg-80 xl:h-80 sm:h-1 md:h-20' />
<div className='  w-full  h-5 lg-80 xl:h-80 sm:h-1 md:h-20' />
{shout4()}
 
<div className='  w-full  h-5 lg-80 xl:h-80 sm:h-1 md:h-20 rounded-md' />
<div class=" ml-4 mr-4 ">
      <dl class="grid grid-cols-1 gap-4  sm:grid-cols-3">
      <div
          class="flex flex-col py-8 text-center hover:opacity-60  "
        >
          <dt class="order-last text-lg font-medium text-gray-500">
          <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1670389198521-IMG_2484.jpg" class="rounded-l-lg  h-full w-full object-contain"/>
          </dt>

        </div>
        <div
          class="flex flex-col py-8 text-center hover:opacity-60  "
        >
          <dt class="order-last text-lg font-medium text-gray-500">
          <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1670389235323-IMG_2498.jpg" class="rounded-l-lg  h-full w-full object-contain"/>
          </dt>

        </div>
        <div
          class="flex flex-col py-8 text-center hover:opacity-60  "
        >
          <dt class="order-last text-lg font-medium text-gray-500">
          <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1670389336599-IMG_2531.jpg" class="rounded-l-lg  h-full w-full object-contain"/>
          </dt>

        </div>
        <div
          class="flex flex-col py-8 text-center hover:opacity-60  "
        >
          <dt class="order-last text-lg font-medium text-gray-500">
          <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1670389460811-20220820-IMG_1147%202.jpg" class="rounded-l-lg  h-full w-full object-contain"/>
          </dt>

        </div>
        <div
          class="flex flex-col py-8 text-center hover:opacity-60  "
        >
          <dt class="order-last text-lg font-medium text-gray-500">
          <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1670389491875-20220820-IMG_1157.jpg" class="rounded-l-lg  h-full w-full object-contain"/>
          </dt>

        </div>
        <div
          class="flex flex-col py-8 text-center hover:opacity-60  "
        >
          <dt class="order-last text-lg font-medium text-gray-500">
          <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1670389579060-20220820-IMG_1185.jpg" class="rounded-l-lg  h-full w-full object-contain"/>
          
          </dt>

        </div>

        <div
          class="flex flex-col py-8 text-center hover:opacity-60  "
        >
          <dt class="order-last text-lg font-medium text-gray-500">
          <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1670426971244-IMG_8431%20%281%29.jpeg" class="rounded-l-lg  h-full w-full object-contain"/>
          </dt>

        </div>
        <div
          class="flex flex-col py-8 text-center hover:opacity-60 "
        >
          <dt class="order-last text-lg font-medium text-gray-500">
          <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1659879246586-IMG_8584%202.jpg" class="  h-full w-full object-contain"/>
          </dt>

        </div>

        <div
          class="flex flex-col py-8  text-center hover:opacity-60  "
        >
          <dt class="order-last text-lg font-medium text-gray-500">
            <img src="https://localflowershop.sgp1.digitaloceanspaces.com/product/1670427974458-IMG_8335%20%281%29.jpeg" class=" rounded-r-lg  w-full object-contain"/>
          </dt>
          {/* https://localflowershop.sgp1.digitaloceanspaces.com/product/1670251164360-smartdesk-wood.jpeg */}

        </div>
      </dl>
    </div>




    <div className='  w-full  h-5 lg-80 xl:h-80 sm:h-1 md:h-20' />
{/* <div className='  w-full  h-5 lg-80 xl:h-80 sm:h-1 md:h-20' /> */}
<div style={{width:'90%',height:0.1,backgroundColor:'#dcdde1',marginTop:200}} className="mr-auto ml-auto"/>
<div className='ml-8 mb-10 mt-20'>
  < >
  <h2 class="text-gray-800 md:text-5xl text-3xl font-extralight mb-12 text-center">
   Explore SmartDesk Media
   </h2>
  </>
</div>

    <div class="  items-center justify-center bg-white grid grid-cols-1 lg:gap-3 gap:1 lg:grid-cols-3">
  
  <div className='rounded-md ml-8 lg:mb-20 bg-white hover:shadow-lg items-center justify-center align-middle' style={{width:412,height:800}}>
      
  <ReactPlayer width={412} height={767}  controls={true} loop={true} url='https://www.youtube.com/shorts/4Qw703YChrc'  />
  </div>
  <div className='rounded-md  ml-8  mb-20   bg-white hover:shadow-lg items-center justify-center align-middle' style={{width:412,height:800}}>
  
  <ReactPlayer width={412} height={767}  controls={true} loop={true} url='https://www.youtube.com/shorts/39R9gM_iwYQ'  />
  </div>
  <div className='rounded-md ml-8 bg-white  mb-20  hover:shadow-lg items-center justify-center align-middle' style={{width:412,height:800}}>
  
  <ReactPlayer width={412} height={767}  controls={true} loop={true} url='https://www.youtube.com/shorts/aWzHtr3K4mY'  />
  </div>

</div>


<div className='  w-full  h-5 lg-80 xl:h-80 sm:h-1 md:h-20 rounded-md' />

<div style={{width:'90%',height:0.1,backgroundColor:'#dcdde1'}} className="mr-auto ml-auto"/>
<PricingPlan/>

<Reviews/>


        <div className="w-full bg-gray-100">
            
            </div>
            
        {storeDetails !== null ? <Footer details={storeDetails} /> : <MyLoader />}
    
  <MessengerCustomerChat
    pageId="100632342493724"
    appId="459290835669103"
  />
      </div>
    </div>
  );


  function diplsaytIyem() {

const products = [
  {
    id: 1,
    name: 'SM-Frame-DM',
    href: '#',
    imageSrc: 'https://clouddisk.alibaba.com/file/redirectFileUrl.htm?appkey=OneChat&id=687739271&parentId=648781579&secOperateAliId=MC1IDX1kM-MR-7BPeDBIwbElTZ3pPEOK07tBVtyj8FpUP6LloWGv1vCw-QwSZ61E9LoiHzz&fileAction=imagePreview',
    imageAlt: "Standing Desk Frame",
    price: '₱18,000',
    color: 'Black/White',
  },{
    id: 1,
    name: 'Basic Tee',
    href: '#',
    imageSrc: 'https://i.pinimg.com/564x/0b/66/be/0b66be5c5f44653b11d803d5de20fbe9.jpg',
    imageAlt: "Table Top",
    price: '$35',
    color: 'Black',
  },{
    id: 1,
    name: 'Basic Tee',
    href: '#',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/product-page-01-related-product-01.jpg',
    imageAlt: "Front of men's Basic Tee in black.",
    price: '$35',
    color: 'Black',
  },{
    id: 1,
    name: 'Basic Tee',
    href: '#',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/product-page-01-related-product-01.jpg',
    imageAlt: "Front of men's Basic Tee in black.",
    price: '$35',
    color: 'Black',
  },{
    id: 1,
    name: 'Basic Tee',
    href: '#',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/product-page-01-related-product-01.jpg',
    imageAlt: "Front of men's Basic Tee in black.",
    price: '$35',
    color: 'Black',
  }
  // More products...
]
  return (
    <div className="bg-white">
      <div className="max-w-2xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
        <h2 className="text-2xl font-light tracking-tight text-gray-900">To order</h2>

        <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
          {products.map((product) => (
            <div key={product.id} className="group relative">
              <div className="w-full min-h-80 bg-gray-200 aspect-w-1 aspect-h-1 rounded-md overflow-hidden group-hover:opacity-75 lg:h-80 lg:aspect-none">
                <img
                  src={product.imageSrc}
                  alt={product.imageAlt}
                  className="w-full h-full object-center object-cover lg:w-full lg:h-full"
                />
              </div>
              <div className="mt-4 flex justify-between">
                <div>
                  <h3 className="text-sm text-gray-700">
                    <a href={product.href}>
                      <span aria-hidden="true" className="absolute inset-0" />
                      {product.name}
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">{product.color}</p>
                </div>
                <p className="text-sm font-medium text-gray-900">{product.price}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
  }
 
}

export default App;
 

     {/* <div className={hasVoucher ? "sticky top-5 sm:top-10  z-10 flex-1 overflow-y-auto  lg:h-15 sm:h-10  transform transition duration-400" : "shadow transform transition duration-400 sticky top-0 z-10  lg:h-15 sm:h-10 xs:h-5  "} style={{ backgroundColor: 'white' }}>
        <div class="flex ... items-center   lg:justify-center   overflow-y-auto overflow-x-auto " >
          {categories.length ? renderCategories() : <CategoryPH />}
        </div>
      </div> */}
